/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * response of POST /media_list/prtimes_media_lists
 * @export
 * @interface CreateMediaListResponse
 */
export interface CreateMediaListResponse {
    /**
     * HTTPステータスコード
     * @type {number}
     * @memberof CreateMediaListResponse
     */
    status?: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof CreateMediaListResponse
     */
    message?: string;
}

export function CreateMediaListResponseFromJSON(json: any): CreateMediaListResponse {
    return CreateMediaListResponseFromJSONTyped(json, false);
}

export function CreateMediaListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMediaListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function CreateMediaListResponseToJSON(value?: CreateMediaListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

